import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrInsightsContentSectionHeaderBigCls: string;
			communityPlsrInsightsContentSectionHeaderCls: string;
			communityPlsrInsightsContentSectionSubheaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Insights Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsContentSectionHeaderBigCls || '', 'community_plsr_insights_hero', { animCls: 'animate__lightSpeedInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsContentSectionHeaderCls || '', 'community_plsr_insights_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsContentSectionSubheaderCls || '', 'community_plsr_insights_hero', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;